import React from 'react'
import BlackButton from '../Buttons/BlackButton/BlackButton'
import "./Footer.css"
export default function Footer() {
  return (
    <div className='footer__container'><BlackButton text="Call Now" function="call" /></div>
  )
}
